export const GA_MEASUREMENT_ID = "G-0LEM19PZBD";
